<template>
  <div class="el-table-container templateBox">
    <el-form size="small" :inline="true" class="query-form" ref="searchForm" :model="searchForm"
             @keyup.enter.native="refreshList(1)" @submit.native.prevent label-width="80px">
      <el-form-item label="关键字" prop="keyWord">
        <el-input v-model.trim="searchForm.keyWord" maxlength="20" placeholder="请输入关键字(限20字)"
                  clearable></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="refreshList(1)" size="small" icon="el-icon-search">查询</el-button>
        <el-button @click="reset()" size="small" icon="el-icon-refresh-right">重置</el-button>
      </el-form-item>
      <el-form-item class="f_r">
        <el-button v-if="hasPermission('sys:authorize:authorize:add')" type="primary" size="small"
                   icon="el-icon-plus" @click="setRowData('add')">新增
        </el-button>
        <el-button v-if="hasPermission('sys:authorize:authorize:deleteData')" type="danger" size="small"
                   icon="el-icon-delete" @click="deleteColumn()">批量删除
        </el-button>
      </el-form-item>
    </el-form>
    <div class="tips">
      <el-link class="el-icon-info" type="primary" :underline="false"></el-link>
      已选择{{ dataListSelect.length }}项数据
    </div>
    <el-table
        :data="dataList"
        v-loading="loading"
        @sort-change="sortChangeHandle"
        size="small" height="100%"
        class="table" border
        ref="multipleTable"
        :row-key="'id'"
        @selection-change="selectionChangeHandle"
    >
      <el-table-column :reserve-selection="true" type="selection" width="50"/>
      <el-table-column prop="mobilePhone" label="授权账号" width="150px"></el-table-column>
      <el-table-column prop="accreditIp" label="授权IP" show-overflow-tooltip></el-table-column>
      <el-table-column prop="accreditDate" label="授权时间" show-overflow-tooltip></el-table-column>
      <el-table-column prop="accreditReason" label="授权原因" show-overflow-tooltip></el-table-column>
      <el-table-column prop="accreditStatus" label="状态" show-overflow-tooltip>
        <template slot-scope="{row}">
          <el-switch
              v-model="row.accreditStatus"
              active-value="0"
              @change="setType(row)"
              inactive-value="1">
          </el-switch>
        </template>
      </el-table-column>
      <el-table-column prop="updateByName" label="最新修改人" show-overflow-tooltip></el-table-column>
      <el-table-column prop="updateDate" sortable="custom" label="最新修改时间" show-overflow-tooltip></el-table-column>
      <el-table-column prop="createByName" label="创建人" show-overflow-tooltip></el-table-column>
      <el-table-column prop="createDate" sortable="custom" label="创建时间" show-overflow-tooltip></el-table-column>
      <el-table-column min-width="100px" fixed="right" label="操作">
        <template slot-scope="{row}">
          <el-button v-if="hasPermission('sys:authorize:authorize:edit')" type="text"
                     size="small" @click="setRowData('edit',row)">编辑
          </el-button>
          <el-button v-if="hasPermission('sys:authorize:authorize:deleteData')" type="text"
                     size="small" @click="deleteColumn(row)">删除
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <pagination :total="total" :page.sync="searchForm.current" :limit.sync="searchForm.size"
                @pagination="refreshList"/>

    <add-authorize ref="addAuthorize" @refresh="refreshList(1,1)"></add-authorize>
  </div>
</template>

<script>

import AddAuthorize from "@/views/modules/sys/authorize/addAuthorize.vue";

export default {
  name: "authorize",
  components: {AddAuthorize},
  data() {
    return {
      searchForm: {
        keyWord: '',
        sort: '',
        current: 1,
        size: 20,
      },
      total: 0,

      loading: false,
      dataList: [],
      dataListSelect: [],
    }
  },

  mounted() {
    this.refreshList()
  },

  methods: {
    // 获取数据列表 current查第几页数据
    refreshList(type, clearSelect) {
      if (type == 1) {
        this.searchForm.current = 1
      }
      if (clearSelect) {
        this.$refs.multipleTable.clearSelection()
      }
      this.loading = true
      this.$axios(this.api.user.sysUserAccreditList, this.searchForm).then(data => {
        if (data && data.status) {
          this.dataList = data.data.records
          if (this.dataList.length == 0 && this.searchForm.current > 1) {
            this.searchForm.current--
            this.refreshList()
          }
          this.total = parseInt(data.data.total)
          this.loading = false
        } else {
          this.$message.error('查询失败')
        }
      })
    },

    // 重置
    reset() {
      this.$refs.searchForm.resetFields();
      this.refreshList(1, 1)
    },

    //表格勾选数据
    selectionChangeHandle(val) {
      this.dataListSelect = val
    },

    //切换状态
    setType(row) {
      row.accreditStatus = row.accreditStatus == '1' ? '0' : '1'
      this.$axios(this.api.user.updateAccreditStatusById, {
        id: row.id,
        accreditStatus: row.accreditStatus == '1' ? '0' : '1',
      }, 'put').then(data => {
        if (data && data.status) {
          this.$message.success('状态修改成功')
          this.refreshList()
        } else {
          this.$message.error(data.msg)
        }
      })
    },

    // add新增 edit编辑
    setRowData(setName, row) {
      this.$refs.addAuthorize.init(setName, row)
    },

    // 排序
    sortChangeHandle(obj) {
      let proName
      if (obj.prop == "updateDate"){
        proName = 'update_date'
      }
      if (obj.prop == "createDate"){
        proName = 'create_date'
      }
      if (obj.order === 'ascending') {
        this.searchForm.sort = proName + ' asc'
      } else if (obj.order === 'descending') {
        this.searchForm.sort = proName + ' desc'
      } else {
        this.searchForm.sort = ''
      }
      this.refreshList(1,1)
    },

    //强制登出
    deleteColumn(row) {
      let list = row ? [row] : this.dataListSelect
      if (list.length == 0) {
        this.$message.warning('请至少选择一个用户')
        return
      }
      let statusTrueList = []
      let ids = list.map(item => {
        if (item.accreditStatus == 0) {
          statusTrueList.push(item)
        }
        return item.id
      })
      if (statusTrueList.length != 0) {
        this.$message.warning('请先禁用后再删除！')
        return
      }
      this.$confirm(`您是否确认删除数据?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$axios(this.api.user.sysUserAccreditRemoveByIds, ids, 'post').then(data => {
          if (data && data.status) {
            this.$message.success('删除成功')
            this.refreshList('', 1)
          } else {
            this.$message.error(data.msg)
          }
        })
      })
    },


  },
}
</script>

<style scoped>
</style>
